import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import { fetchRequestTypes } from "./Utils/archRequest.api";

const ArchitecturalRequestsCards = ({ requests = [], getStatusDetails }) => {
  const [requestTypes, setRequestTypes] = useState([]);

  useEffect(() => {
    const loadRequestTypes = async () => {
      try {
        const types = await fetchRequestTypes();
        setRequestTypes(types);
      } catch (error) {
        console.error("Error fetching request types:", error);
      }
    };

    loadRequestTypes();
  }, []);

  const getRequestTypeName = (typeId) => {
    const found = requestTypes.find((t) => Number(t.id) === Number(typeId));
    return found?.type || "Unknown Type";
  };
  

  if (!Array.isArray(requests)) return null;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        {requests.map((r) => {
          const { color, Icon, label } = getStatusDetails(r.status || "");

          return (
            <Grid item xs={12} sm={6} md={4} key={r.id}>
              <Card
                sx={{
                  borderLeft: (theme) =>
                    `4px solid ${theme.palette[color]?.main || color}`,
                  padding: 2,
                  borderRadius: 2,
                  boxShadow: 2,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <CardContent sx={{ paddingBottom: "16px !important" }}>
                  <Typography variant="subtitle1" fontWeight="bold" noWrap>
                    REQ-{r.id}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    fontWeight="bold"
                    noWrap
                  >
                    Property ID: {r.property_id || "N/A"}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                    noWrap
                  >
                    {getRequestTypeName(r.request_type)}
                  </Typography>

                  <Chip
                    icon={
                      Icon ? (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Icon sx={{ color: "#fff", fontSize: 20 }} />
                        </Box>
                      ) : null
                    }
                    label={label.toUpperCase()}
                    sx={{
                      backgroundColor: (theme) =>
                        theme.palette[color]?.main || color,
                      color: "#fff",
                      fontWeight: "bold",
                      mb: 1,
                    }}
                  />

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    {r.requested_at
                      ? new Date(r.requested_at).toLocaleDateString()
                      : "N/A"}
                  </Typography>

                  <Button
                    component={Link}
                    to={`${r.id}`}
                    variant="outlined"
                    size="small"
                    sx={{ mt: "auto" }}
                  >
                    View Details
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ArchitecturalRequestsCards;
